import { Paper, Typography, CircularProgress, Box } from "@mui/material"

const formattedValue = (num, precision = 0) =>
    Number(num).toLocaleString(undefined, {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
    })

export function CircularCounter({ title, value, color, precision = 0, options = {} }) {
    let displayValue = formattedValue(value, precision)
    let fillPercent = 100
    if (options.maxValue) {
        fillPercent = (displayValue / options.maxValue) * 100
        displayValue = `${displayValue}/${options.maxValue}`
    }

    return (
        <Paper
            elevation={3}
            style={{
                padding: 10,
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                width: 180,
                height: 220,
                borderRadius: 10, // Slightly rounded corners
            }}
        >
            <Box
                sx={{
                    minHeight: 60, // Adjusted to be more compact
                    width: "95%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "2px solid rgba(0, 0, 0, 0.01)", // Lighter border
                    borderRadius: 2, // Less rounded
                    padding: "3px 8px",
                    textAlign: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.015)", // Softer contrast
                    fontSize: "0.85rem", // Slightly smaller font
                    fontWeight: 500, // Less bold
                }}
            >
                {title}
            </Box>
            <Box sx={{ position: "relative", width: 120, height: 120, marginTop: 5 }}>
                <CircularProgress
                    variant="determinate"
                    value={fillPercent} // Always full
                    size={120}
                    thickness={6}
                    sx={{
                        color: value === "N/A" ? "#ccc" : color, // Gray fallback for missing values
                        position: "absolute",
                        top: "-30%",
                        left: 0,
                    }}
                />
                <Typography
                    variant="h5"
                    style={{
                        position: "absolute",
                        top: "30%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontWeight: "bold",
                    }}
                >
                    {displayValue}
                </Typography>
            </Box>
        </Paper>
    )
}

//bla
